var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("radio-select-link", {
        attrs: {
          options: _vm.options,
          radioSelected: _vm.cardCustomSettings.displayMode
        },
        on: { updateSelect: _vm.updateSelect, updateRadio: _vm.updateRadio },
        model: {
          value: _vm.form.displayMode,
          callback: function($$v) {
            _vm.$set(_vm.form, "displayMode", $$v)
          },
          expression: "form.displayMode"
        }
      }),
      _vm._v(" "),
      _vm.cardSettings.provider !== "sellsy"
        ? [
            _c("p", { staticClass: "semibold mb-1 mt-3" }, [
              _vm._v(_vm._s(_vm.$l10n.__("Calendriers")))
            ]),
            _vm._v(" "),
            _c(
              "el-form-item",
              { attrs: { prop: "calendars" } },
              [
                _c(
                  "p",
                  {
                    staticClass: "grey mb-1",
                    attrs: { slot: "label" },
                    slot: "label"
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$l10n.__(
                            "Sélectionnez les calendriers que vous souhaitez afficher."
                          )
                        ) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "wp-5 flex-level flex-column h-160",
                    model: {
                      value: _vm.form.calendars,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "calendars", $$v)
                      },
                      expression: "form.calendars"
                    }
                  },
                  _vm._l(_vm.cardSettings.calendars, function(calendar) {
                    return _c(
                      "el-checkbox",
                      {
                        key: calendar.id,
                        staticClass: "calendar-settings-checkbox",
                        style: { color: calendar.backgroundColor },
                        attrs: { label: calendar.id }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(calendar.name) +
                            "\n                "
                        )
                      ]
                    )
                  }),
                  1
                )
              ],
              1
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "aright mt-5" },
        [
          _c("CompassButton", {
            attrs: {
              label: _vm.$t.__("common.actions.cancel"),
              type: "secondary"
            },
            on: { click: _vm.close }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "ml-3",
            attrs: { label: _vm.$t.__("common.actions.save"), type: "primary" },
            on: { click: _vm.submitForm }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }